module.exports = __webpack_public_path__ + "static/wholesale-product-section-3c78507d46f36f5a17df9fdc969c8c06.png";